webpackJsonp([164055321636205],{

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/character--keoni-shaka@3x.353e4dc8.png";

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: block;  \n  '], ['\n    display: block;  \n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(4);
	
	var _Heading = __webpack_require__(15);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _characterKeoniShaka3x = __webpack_require__(59);
	
	var _characterKeoniShaka3x2 = _interopRequireDefault(_characterKeoniShaka3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var visuallyHiddenStyle = {
	  border: 0,
	  clip: 'rect(0 0 0 0)',
	  height: '1px',
	  margin: '-1px',
	  overflow: 'hidden',
	  padding: 0,
	  position: 'absolute',
	  width: '1px'
	};
	
	var RulesPage = function RulesPage() {
	  return _react2.default.createElement(
	    Section,
	    { 'aria-label': 'Official Contest Rules' },
	    _react2.default.createElement(
	      HeadingContent,
	      { fullWidth: true },
	      'Blue Planet Foundation and',
	      ' ',
	      _react2.default.createElement(
	        'span',
	        { style: { 'white-space': 'nowrap' } },
	        'Hawai\u2018i Energy'
	      ),
	      ' ',
	      'Efficiency Unlocked Giveaway ',
	      _react2.default.createElement(
	        'div',
	        null,
	        'Official Contest Rules:'
	      )
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Official Rules for "Blue Planet Foundation and Hawai\u2018i Energy Efficiency Unlocked Giveaway," ("Contest") ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'May 23, 2022 \u2013 June 6, 2022.'
	      )
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Blue Planet Foundation will conduct this Contest as described in these general contesting rules, and each participant agrees to the following:'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'By playing, each participant accepts and agrees to be bound by these official rules. NO PURCHASE NECESSARY. Must be 18 years of age or older, a fulltime resident of Hawai\u2018i and an electric utility ratepayer on the island of Hawai\u2018i,',
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': true },
	        'L',
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'inline-block', position: 'relative' } },
	          'a',
	          _react2.default.createElement(
	            'span',
	            {
	              style: {
	                position: 'absolute',
	                'user-select': 'none',
	                top: -7,
	                left: 1
	              }
	            },
	            '-'
	          )
	        ),
	        'na\u2018i,'
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: visuallyHiddenStyle },
	        'Lana\u2018i'
	      ),
	      'Maui, Moloka\u2018i or O\u2018ahu to participate. Multiple submissions will not be accepted. Void where prohibited.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'To play, beginning ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'May 23, 2022 \u2013 June 6, 2022.'
	      )
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Upon completion of navigating through the home energy tips on the efficiencyunlocked.org microsite, complete all the fields on the Contest entry form (including your first name, last name, zip code/postal code, phone number and email address). Multiple submissions will not be accepted.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'You may also enter by mailing in one self-addressed, stamped envelope and one 3" x 5" hand-written card. Card must contain customer\'s first name, last name, home address, zip code/postal code, phone number, email address, "Efficiency Unlocked 2020" written at the top of the card and the numbered answers to the following survey questions:'
	    ),
	    _react2.default.createElement(
	      List,
	      null,
	      _react2.default.createElement(
	        ListItem,
	        null,
	        _react2.default.createElement(
	          Text,
	          null,
	          _react2.default.createElement(
	            'em',
	            null,
	            'Have you participated in any program or received a rebate from Hawai\'i Energy?'
	          )
	        ),
	        _react2.default.createElement(
	          SubList,
	          null,
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              'Yes'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              'No'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        ListItem,
	        null,
	        _react2.default.createElement(
	          Text,
	          null,
	          _react2.default.createElement(
	            'em',
	            null,
	            'What have you done for your home to make it more energy efficient (include all letters that apply):'
	          )
	        ),
	        _react2.default.createElement(
	          SubList,
	          null,
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              'Solar water heating'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              'Use ENERGY STAR\xAE appliances'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              'Use ENERGY STAR\xAE LED lighting'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              'Use ENERGY STAR\xAE air conditioning'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              'Other: ____________________'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        ListItem,
	        null,
	        _react2.default.createElement(
	          Text,
	          null,
	          _react2.default.createElement(
	            'em',
	            null,
	            'What\'s the best way to provide you info on how to save on your electric bill? Please rank the order from 1-9, 1 being the best way:'
	          )
	        ),
	        _react2.default.createElement(
	          SubList,
	          null,
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ Email'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ Mail: postcard, letter'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ In my electric bill'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ Online ads: social media, search'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ Media: TV, radio'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ Newspaper ads'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ Word-of-mouth'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ At stores where I\'m buying'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ At events'
	            )
	          ),
	          _react2.default.createElement(
	            SubListItem,
	            null,
	            _react2.default.createElement(
	              Text,
	              null,
	              '___ Home Energy Report'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Only one card mail-in request per person before June 6, 2022, allowed. Cards post marked after June 6, 2022, will be discarded. Illegible cards will be discarded and deemed void. No facsimile or copies will be allowed. Mail hand-written card requests to: Blue Planet Foundation, ATTN: Efficiency Unlocked 2020, 55 Merchant Street Suite 1700, Honolulu HI 96813. By entering the Contest, you are opting in to receive various email updates from Blue Planet Foundation and Hawai\u2018i Energy. You may opt-out at any time.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Sponsors are not responsible for lost, late, illegible, incomplete or misdirected entries.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Any valuation of the prize is based on available information provided to the Blue Planet Foundation, and the value of any prize awarded to a winner may be reported for tax purposes as required by law. Each winner is solely responsible for reporting and paying any and all applicable taxes related to the prize and paying any expenses associated with any prize which is not specifically provided for in the official rules. The winner must provide Blue Planet Foundation with valid identification and a valid taxpayer identification number or social security number before any prize will be awarded and will receive an IRS form 1099 at the end of the calendar year and a copy of such form will be filed with the IRS.',
	      ' '
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Only the prize winner may claim the prize. No proxies permitted. Prior to delivery of the prize, winner is required to execute a Release and Affidavit of Eligibility that must be received by the Sponsor within ten (10) days from winner\u2019s receipt of the Release and Affidavit of Eligibility form. Failure to complete, execute and deliver the Release and Affidavit of Eligibility in the time and manner specified above could result in forfeiture of the prize. Upon acceptance of the prize, winner releases Blue Planet Foundation and sponsors from any and all liability for injury or damage to property regarding the prize.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Prize may not be exchanged for cash. No substitution of prize permitted. The depiction of the prize in any advertising or promotional materials may not reflect the actual prize to be awarded. Winner may not transfer the prize.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Entries will be reviewed beginning June 7, 2022 and winners will be contacted by phone and/or e-mail no later than June 8, 2022. If a winner(s) cannot be contacted by June 15, 2022 or is/are disqualified for any reason, Blue Planet Foundation reserves the right to determine an alternate winner or not to award that winner\u2019s prize, in its sole discretion.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Winner agrees to the use of his/her/their name(s) and likeness(es), without any additional compensation, by Sponsors for publicity. By entering this promotion, the winner acknowledges that all Sponsors and venues have the right to publicize his/her/their name(s), voice(s), and likeness(es), the fact that he/she/they won, and all matters incidental thereto. Sponsors to include winners\' names, photographs, recordings, etc. in any subsequent promotions, new releases or advertisements.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'By participating in the Contest, participants agree to be bound by the decisions of Blue Planet Foundation personnel. Persons who violate any rule, gain unfair advantage in participating in the Contest, or obtain winner status using fraudulent means will be disqualified. Unsportsmanlike, disruptive, annoying, harassing or threatening behavior is prohibited. Blue Planet Foundation will interpret these rules and resolve any disputes, conflicting claims or ambiguities concerning the rules or the Contest and Blue Planet Foundation\u2019s decisions concerning such disputes shall be final. If the conduct or outcome of the Contest is affected by human error, any mechanical malfunctions or failures of any kind, intentional interference or any event beyond the control of Blue Planet Foundation, Blue Planet Foundation reserves the right to terminate this Contest, or make such other decisions regarding the outcome as Blue Planet Foundation deems appropriate. All decisions will be made by Blue Planet Foundation and are final. Blue Planet Foundation may waive any of these rules in its sole discretion. Any attempt by an entrant or any other individual to deliberately circumvent, disrupt, damage or undermine the legitimate operation of this Contest is a violation of criminal and civil laws. Should such an attempt be made, Blue Planet Foundation reserve the right to seek civil and/or criminal prosecution and/or damages from any such person to the fullest extent permitted by law.'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      'Each winner must submit proof of eligibility and sign Blue Planet Foundation\u2019s release form to claim the prize. Blue Planet Foundation may substitute prizes, amend the rules or discontinue the Contest any time. Blue Planet Foundation disclaims any responsibility to notify participants of any aspect related to the conduct of the Contest. For a copy of the list of winners or a copy of the rules, send a self-addressed, stamped envelope to: Blue Planet Foundation, 55 Merchant Street, Suite 1700, Honolulu, HI 96813, ATTN: Efficiency Unlocked 2020. All entries become the property of Blue Planet Foundation and will not be returned.'
	    ),
	    _react2.default.createElement(CharacterPluggy, { src: _characterKeoniShaka3x2.default })
	  );
	};
	
	exports.default = RulesPage;
	
	
	var Section = _styledComponents2.default.section.withConfig({
	  displayName: 'rules__Section'
	})(['position:relative;max-width:', 'px;width:100%;margin:0 auto;padding:', ';border-radius:', ';background-color:', ';box-shadow:0 0.75rem 1.5rem rgba(0,0,0,0.25);'], function (p) {
	  return p.theme.mediaSizes.extraLarge;
	}, function (p) {
	  return p.theme.spacing(2.5);
	}, function (p) {
	  return p.theme.radius(2);
	}, function (p) {
	  return p.theme.color.white;
	});
	
	var CharacterPluggy = _styledComponents2.default.img.withConfig({
	  displayName: 'rules__CharacterPluggy'
	})(['display:none;position:absolute;width:90px;top:10px;left:80px;', ';'], _theme.media.greaterThan('extraLarge')(_templateObject));
	
	var HeadingContent = (0, _styledComponents2.default)(_Heading2.default).withConfig({
	  displayName: 'rules__HeadingContent'
	})(['max-width:40ch;margin:0 auto 2rem;text-align:center;line-height:1;color:#eda44d;div{font-size:', ';color:#5a696f;margin-top:0.5rem;}'], function (p) {
	  return p.theme.fontSize(1.45);
	});
	
	var Text = _styledComponents2.default.p.withConfig({
	  displayName: 'rules__Text'
	})(['color:#3b474c;font-size:', ';line-height:1.25;margin-bottom:1em;&:last-of-type{margin:0;}em{color:#059ca6;text-transform:uppercase;font-size:', ';}'], function (p) {
	  return p.theme.fontSize(1.35);
	}, function (p) {
	  return p.theme.fontSize(1.5);
	});
	
	var List = _styledComponents2.default.ol.withConfig({
	  displayName: 'rules__List'
	})(['padding-left:2.5rem;']);
	
	var ListItem = _styledComponents2.default.li.withConfig({
	  displayName: 'rules__ListItem'
	})(['position:relative;counter-increment:step-counter;margin-top:1.25rem;&::before{display:flex;justify-content:center;align-items:center;content:counter(step-counter);position:absolute;left:-2.5rem;top:3px;width:1.5rem;height:1.55rem;border-radius:50%;font-size:', ';color:#533108;background-color:#eda44d;padding:0.85rem;}'], function (p) {
	  return p.theme.fontSize(1.2);
	});
	
	var SubList = _styledComponents2.default.ol.withConfig({
	  displayName: 'rules__SubList'
	})(['margin-top:0.25rem;list-style:none;padding-left:1.5rem;']);
	
	var SubListItem = _styledComponents2.default.li.withConfig({
	  displayName: 'rules__SubListItem'
	})(['position:relative;display:list-item;&::before{content:\'\u2022\';position:absolute;left:-1.5rem;top:-2px;color:#059ca6;font-size:', ';}'], function (p) {
	  return p.theme.fontSize(2);
	});
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-rules-js-8cdbfbc179d2961e0eac.js